module.exports = __webpack_public_path__ + "assets/logo-black.ad90e794.svg";